import React, { useEffect, useState } from "react";
import InitialStep from "./InitialStep";
import CheckUserIdStep from "./CheckUserIdStep";
import { CsrfContext } from "../context/CsrfContext";
import ActivateStep from "./ActivateStep";
import { FetchGet } from "../utils/fetch";

enum Step {
    Initial,
    CheckUserId,
    Activate
}

interface RegistrationWizardProps {
}

const RegistrationWizard: React.FC<RegistrationWizardProps> = () => {
    const [step, setStep] = useState(Step.Initial);
    const [userId, setUserId] = useState("");
    const [token, setToken] = useState<string>("");

    const onNextStep = () => {
        switch (step) {
            case Step.Initial:
                setStep(Step.CheckUserId);
                break;
            case Step.CheckUserId:
                setStep(Step.Activate);
                break;
        }
    }

    const goBack = () => {
        switch (step) {
            case Step.CheckUserId:
            case Step.Activate:
                setStep(Step.Initial);
                break;
        }
    }
    
    useEffect(() => {
        FetchGet("start", (json) => {setToken(json.csrfToken.token)});
    }, []);

    return <CsrfContext.Provider value={{ csrfToken: token }}>
        {switchFunc()}
    </CsrfContext.Provider>;

    function switchFunc() {
        switch (step) {
            case Step.Initial:
                return <InitialStep onNextStep={onNextStep} setUserId={setUserId} />;
            case Step.CheckUserId:
                return <CheckUserIdStep goNextStep={onNextStep} goBack={goBack} userId={userId} />;
            case Step.Activate:
                return <ActivateStep goNextStep={onNextStep} goBack={goBack} userId={userId} />;
            default:
                return <p>Step error</p>;
        }
    }
}

export default RegistrationWizard;